/**
 * Author: Arnulfo Ferro Zapata
 * Job Title: Fullstack
 * Email: azpata@ibl.mx
 * Created At: 30 de 04 de 2026
 */

import React from "react";
import DivContainerBody from "../../../../components/DivContainerBody";
import CustomCard from "../../../../components/CustomCard";
import {
    IconCardRelay, IconCondonation,
    IconTitleBuilding,
    IconTitleDeviceDetails, IconTitleEntryMethod,
    IconTitleOptions, PersonOutlinedChip
} from "../../../../components/buttons/IconButtons";
import SummaryContainerDetails from "./SummaryContainerDetails";
import SummaryContainerSecurity from "./SummaryContainerSecurity";
import SummaryContainerOptions from "./SummaryContainerOptions";
import SummaryContainerAuthentication from "./SummaryContainerAuthentication";
import SummaryContainerRelay from "./SummaryContainerRelay";
import SummaryContainerEmpFA from "./SummaryContainerEmpFA";
import SummaryContainerDepaFA from "./SummaryContainerDepaFA";
import {UserRestrictionItem} from "../../Restrictions/Subcomponents/UserRestrictionItem";

const SummarySection = ({ icon: Icon, title, children }) => (
    <CustomCard className="mt-3" classes="card-border-8px" classContent="p-0 overflow-hidden">
        <div className="d-flex align-items-center p-3">
            <div><Icon /></div>
            <div className="ml-2">
                <p className="font-color-general-950 ibl-font-w-600 fs-14px">{title}</p>
            </div>
        </div>
        <div className="border-bottom-shades-300" />
        {children}
    </CustomCard>
);

const Summary = ({
                     data,
                     t,
                     selectForDeleteEmp1FA,
                     selectForDeleteDepa1FA,
                     selectForDeleteEmp2FA,
                     selectForDeleteDepa2FA
                 }) => {

    return (
        <DivContainerBody>
            <SummarySection icon={IconTitleDeviceDetails} title={t('details')}>
                <SummaryContainerDetails data={data?.data} t={t} />
            </SummarySection>

            <SummarySection icon={IconTitleOptions} title={t('options')}>
                <SummaryContainerOptions data={data?.options} t={t} />
            </SummarySection>

            <SummarySection icon={IconTitleBuilding} title={t('security')}>
                <SummaryContainerSecurity data={data?.security} t={t} />
            </SummarySection>

            <SummarySection icon={IconTitleEntryMethod} title={t('authentication')}>
                <SummaryContainerAuthentication data={data?.authentication} t={t} />
            </SummarySection>

            <SummarySection icon={IconCardRelay} title={t('relay_configurations')}>
                <SummaryContainerRelay data={data?.relay} t={t} />
            </SummarySection>

            <SummarySection icon={IconCondonation} title={t('1fa')}>
                { data?.unoFa?.openRelayForAll1FA === true
                    ?
                    <UserRestrictionItem
                        id="cb_sum_open_relay_for_all_1_fa"
                        title='open_access_enabled'
                        description='description_allow_open_access'
                        checked={data?.unoFa?.openRelayForAll1FA}
                        disabled={true}
                        className={"m-3"}
                    />
                    : <>
                        <SummaryContainerEmpFA t={t} selectEmp={selectForDeleteEmp1FA} />
                        <SummaryContainerDepaFA t={t} selectDepa={selectForDeleteDepa1FA} />
                    </>
                }
            </SummarySection>

            <SummarySection icon={IconCondonation} title={t('2fa')}>
                { data?.dosFa?.openRelayForAll2FA === true
                    ?
                        <UserRestrictionItem
                            id="cb_sum_open_relay_for_all_2_fa"
                            title='open_access_enabled'
                            description='description_allow_open_access'
                            checked={data?.dosFa?.openRelayForAll2FA}
                            disabled={true}
                            className={"m-3"}
                        />
                    :  <>
                        <SummaryContainerEmpFA t={t} selectEmp={selectForDeleteEmp2FA} />
                        <SummaryContainerDepaFA t={t} selectDepa={selectForDeleteDepa2FA} />
                    </>
                }
            </SummarySection>
        </DivContainerBody>
    );
};

export default Summary;
